var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-expand-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showsSearch,
      expression: "showsSearch"
    }]
  }, [_c('v-card', _vm._b({
    staticClass: "mb-3",
    attrs: {
      "flat": "",
      "outlined": ""
    }
  }, 'v-card', {
    loading: _vm.loading
  }, false), [_c('v-card-title', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v(_vm._s(_vm.label))]), _c('v-card-text', {
    staticClass: "py-0"
  }, [_vm._t("default")], 2), !_vm.hideActions ? _c('v-card-actions', {
    staticClass: "py-0"
  }, [_c('v-spacer'), _c('v-btn', _vm._b({
    attrs: {
      "color": "primary",
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('search');
      }
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-magnify")]), _vm._v(" 검색 ")], 1)], 1) : _vm._e()], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }